import NotificationsPausedIcon from "@mui/icons-material/NotificationsPaused";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import { IconButton, Tooltip, Menu, MenuItem } from "@mui/material";

import { useState } from "react";
import {
  useFinalizePause,
  useFinalizeAuto,
  useFinalizeComplete,
  useFinalizeNever,
} from "models/notes/apiNote";

const NotificationIcon = ({ id, finalization_status, updated_at }) => {
  const updatedDate = new Date(updated_at);
  updatedDate.setHours(updatedDate.getHours() + 1);
  const now = new Date();
  const timeDifference = updatedDate - now;
  const minutesDifference =
    Math.max(0, Math.floor(timeDifference / (1000 * 60))) + 1;
  const notificationTime = `${minutesDifference} minutes from now`;

  const { mutate: finalizeAuto } = useFinalizeAuto();
  const { mutate: finalizePause } = useFinalizePause();
  const { mutate: finalizeComplete } = useFinalizeComplete();
  const { mutate: finalizeNever } = useFinalizeNever();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let tooltip = "";
  let icon = null;
  if (finalization_status == "COMPLETED") {
    tooltip = "Notification already sent";
    icon = <NotificationsIcon color="success" />;
  } else if (finalization_status == "PAUSE") {
    tooltip = "Notification paused";
    icon = <NotificationsPausedIcon />;
  } else if (finalization_status == "NEVER") {
    tooltip = "Notification will never be sent";
    icon = <NotificationsOffIcon />;
  } else if (finalization_status == "AUTO") {
    tooltip = `Notification will be sent in ${notificationTime}`;
    icon = <NotificationsIcon color="warning" />;
  } else {
    tooltip =
      "Notification will be sent very soon and might already be on its way.";
    icon = <NotificationsIcon color="success" />;
  }

  return (
    <>
      <IconButton onClick={handleClick} sx={{ ml: "auto" }} edge="end">
        <Tooltip title={tooltip}>{icon}</Tooltip>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            finalizePause(id);
            handleClose();
          }}
        >
          Pause
        </MenuItem>
        <MenuItem
          onClick={() => {
            finalizeNever(id);
            handleClose();
          }}
        >
          Never
        </MenuItem>
        <MenuItem
          onClick={() => {
            finalizeComplete(id);
            handleClose();
          }}
        >
          Send now
        </MenuItem>
        <MenuItem
          onClick={() => {
            finalizeAuto(id);
            handleClose();
          }}
        >
          Auto
        </MenuItem>
      </Menu>
    </>
  );
};

export default NotificationIcon;
